import React from 'react';

export const useExpandableText = (
  textRef: React.RefObject<HTMLParagraphElement>
) => {
  const [showMore, setShowMore] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);

  React.useEffect(() => {
    if (textRef.current) {
      setShowMore(textRef.current.scrollHeight > textRef.current.offsetHeight);
    }
  }, [textRef.current]);

  return { showMore, expanded, setExpanded };
};
